import { RouteWithHeaderBackButton } from 'core/Hooks';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AccountPage } from '~/pages/Account/AccountPage';
import { AddCard } from '~/pages/Account/AddCard/AddCard';
import { MembershipPage } from '~/pages/Account/Memberships/MembershipPage';
import { EarningsPage } from '~/pages/Account/Rewards/EarningsPage';
import { AccountTicketsPage } from '~/pages/Account/Tickets/TicketPage';
import { EarningEntryPage } from '~/pages/Wallet/Earnings/EarningDetail/EarningDetailPage';
import { WalletEventsPage } from '~/pages/Wallet/Events/WalletEventsPage';
import { PurchaseDetailPage } from '~/pages/Wallet/Purchases/PurchaseDetailPage/PurchaseDetailPage';
import { PurchasesPage } from '~/pages/Wallet/Purchases/PurchasesPage';

const PurchasesRoutes = () => {
  return (
    <Routes>
      <Route
        path=":cartItemId"
        element={
          <RouteWithHeaderBackButton routeTo="/account/purchases">
            <PurchaseDetailPage />
          </RouteWithHeaderBackButton>
        }
      />
      <Route
        index
        element={
          <RouteWithHeaderBackButton routeTo="/account">
            <PurchasesPage />
          </RouteWithHeaderBackButton>
        }
      />
    </Routes>
  );
};

const EarningRoutes = () => {
  return (
    <Routes>
      <Route
        path=":entryId"
        element={
          <RouteWithHeaderBackButton routeTo="/account/rewards">
            <EarningEntryPage />
          </RouteWithHeaderBackButton>
        }
      />
      <Route
        index
        element={
          <RouteWithHeaderBackButton routeTo="/account">
            <EarningsPage />
          </RouteWithHeaderBackButton>
        }
      />
    </Routes>
  );
};

const AccountRoutes = () => {
  return (
    <Routes>
      <Route
        path="card"
        element={
          <RouteWithHeaderBackButton>
            <AddCard />
          </RouteWithHeaderBackButton>
        }
      />
      <Route
        path="events"
        element={
          <RouteWithHeaderBackButton>
            <AccountTicketsPage />
          </RouteWithHeaderBackButton>
        }
      />
      <Route
        path="events/:eventId"
        element={
          <RouteWithHeaderBackButton routeTo="/account/events">
            <WalletEventsPage />
          </RouteWithHeaderBackButton>
        }
      />

      <Route
        path="memberships"
        element={
          <RouteWithHeaderBackButton>
            <MembershipPage />
          </RouteWithHeaderBackButton>
        }
      />

      <Route path="purchases/*" element={<PurchasesRoutes />} />
      <Route path="rewards/*" element={<EarningRoutes />} />
      <Route index element={<AccountPage />} />
      <Route path="*" element={<Navigate to="/account" replace />} />
    </Routes>
  );
};

export { AccountRoutes };
